export default "__VITE_ASSET__BZt7z_w1__ 320w, __VITE_ASSET__D5UHtOuK__ 480w, __VITE_ASSET__DgXbOfe5__ 640w, __VITE_ASSET__X8p58X4t__ 800w";